export const allMutualFundsMock = {
    allMutualFunds: [
        {
            broadAssetClass: "Int'l/Global Equity",
            iClass: false,
            morningStarOverallRating: 0,
            morningStarCategoryName: 'Miscellaneous Region',
            openToNewInvestors: true,
            openToSubsequentInvestments: true,
            redemptionFee: 0,
            riskLevel: 260,
            taxFree: false,
            ticker: 'TRAMX',
            name: 'T. Rowe Price Africa & Middle East Fund',
            trpCode: 'AME',
            selectFund: false,
            __typename: 'GraphQLMutualFund',
            shortName: 'Africa & Middle East Fund',
            morningStarAsOfDate: '2023-01-31T05:00:00Z',
            morningStarOverallQuantity: 0,
            moneyMarket: false,
            moneyMarketType: null,
            ytdMonthlyTotalReturns: -0.92,
            ytdMonthlyAsOfDate: '2023-02-28T05:00:00Z',
            dailyYTDTotalReturns: {
                fundReturn: 4.77,
                asOfDate: '2022-03-07T05:00:00Z',
                __typename: 'FundReturn'
            },
            monthlyAverageAnnualTotalReturns: {
                asOfDate: '2023-02-28T05:00:00Z',
                oneYearReturn: -12.34,
                threeYearReturn: 9.9,
                fiveYearReturn: 1.86,
                tenYearReturn: 4.89,
                sinceInceptionReturn: 2.3,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: false,
                threeYearReturnTacked: false,
                __typename: 'YearlyReturns'
            },
            quarterlyAverageAnnualTotalReturns: {
                asOfDate: '2022-12-31T05:00:00Z',
                oneYearReturn: -5.88,
                threeYearReturn: 5.45,
                fiveYearReturn: 2.91,
                tenYearReturn: 5.18,
                sinceInceptionReturn: 2.39,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: false,
                __typename: 'YearlyReturns'
            },
            inceptionDate: '2007-09-04T04:00:00Z',
            tackedReturnFundInceptionDate: null,
            expenseRatioWaiverType: 'CONTRACTUAL',
            expenseRatioWaiverExpirationDate: '2024-02-29T05:00:00Z',
            grossExpenseRatio: 1.58,
            netExpenseRatio: 1.31,
            redemptionFeePeriod: null,
            riskLevelName: 'Moderate',
            sevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            unsubsidizedSevenDayYieldSimple: null,
            returnsAfterTaxesOnDistribution: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            },
            returnsAfterTaxesOnDistributionAndSales: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            }
        },
        {
            broadAssetClass: "Int'l/Global Equity",
            iClass: true,
            morningStarOverallRating: 0,
            morningStarCategoryName: 'Miscellaneous Region',
            openToNewInvestors: true,
            openToSubsequentInvestments: true,
            redemptionFee: 0,
            riskLevel: 260,
            taxFree: false,
            ticker: 'PRAMX',
            name: 'T. Rowe Price Africa & Middle East Fund - I Class',
            trpCode: 'AMI',
            selectFund: false,
            __typename: 'GraphQLMutualFund',
            shortName: 'Africa & Middle East Fund - I Class',
            morningStarAsOfDate: '2023-01-31T05:00:00Z',
            morningStarOverallQuantity: 0,
            moneyMarket: false,
            moneyMarketType: null,
            ytdMonthlyTotalReturns: -0.92,
            ytdMonthlyAsOfDate: '2023-02-28T05:00:00Z',
            dailyYTDTotalReturns: {
                fundReturn: 4.74,
                asOfDate: '2022-03-07T05:00:00Z',
                __typename: 'FundReturn'
            },
            monthlyAverageAnnualTotalReturns: {
                asOfDate: '2023-02-28T05:00:00Z',
                oneYearReturn: -12.15,
                threeYearReturn: 10.19,
                fiveYearReturn: 2.1,
                tenYearReturn: 5.03,
                sinceInceptionReturn: 2.4,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: true,
                threeYearReturnTacked: false,
                __typename: 'YearlyReturns'
            },
            quarterlyAverageAnnualTotalReturns: {
                asOfDate: '2022-12-31T05:00:00Z',
                oneYearReturn: -5.61,
                threeYearReturn: 5.74,
                fiveYearReturn: 3.17,
                tenYearReturn: 5.33,
                sinceInceptionReturn: 2.48,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: true,
                __typename: 'YearlyReturns'
            },
            inceptionDate: '2017-03-06T05:00:00Z',
            tackedReturnFundInceptionDate: '2007-09-04T04:00:00Z',
            expenseRatioWaiverType: 'CONTRACTUAL',
            expenseRatioWaiverExpirationDate: '2024-02-29T05:00:00Z',
            grossExpenseRatio: 1.32,
            netExpenseRatio: 1.09,
            redemptionFeePeriod: null,
            riskLevelName: 'Moderate',
            sevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            unsubsidizedSevenDayYieldSimple: null,
            returnsAfterTaxesOnDistribution: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            },
            returnsAfterTaxesOnDistributionAndSales: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            }
        },
        {
            broadAssetClass: "Int'l/Global Equity",
            iClass: false,
            morningStarOverallRating: 3,
            morningStarCategoryName: 'Pacific/Asia ex-Japan Stk',
            openToNewInvestors: true,
            openToSubsequentInvestments: true,
            redemptionFee: 0,
            riskLevel: 260,
            taxFree: false,
            ticker: 'TRAOX',
            name: 'T. Rowe Price Asia Opportunities Fund',
            trpCode: 'AOF',
            selectFund: false,
            __typename: 'GraphQLMutualFund',
            shortName: 'Asia Opportunities Fund',
            morningStarAsOfDate: '2023-02-28T05:00:00Z',
            morningStarOverallQuantity: 48,
            moneyMarket: false,
            moneyMarketType: null,
            ytdMonthlyTotalReturns: 2.54,
            ytdMonthlyAsOfDate: '2023-02-28T05:00:00Z',
            dailyYTDTotalReturns: {
                fundReturn: -11.61,
                asOfDate: '2022-03-07T05:00:00Z',
                __typename: 'FundReturn'
            },
            monthlyAverageAnnualTotalReturns: {
                asOfDate: '2023-02-28T05:00:00Z',
                oneYearReturn: -13.69,
                threeYearReturn: 1.43,
                fiveYearReturn: 1.64,
                tenYearReturn: null,
                sinceInceptionReturn: 6.27,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: false,
                threeYearReturnTacked: false,
                __typename: 'YearlyReturns'
            },
            quarterlyAverageAnnualTotalReturns: {
                asOfDate: '2022-12-31T05:00:00Z',
                oneYearReturn: -19.25,
                threeYearReturn: -1.08,
                fiveYearReturn: 1.47,
                tenYearReturn: null,
                sinceInceptionReturn: 6.08,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: false,
                __typename: 'YearlyReturns'
            },
            inceptionDate: '2014-05-21T04:00:00Z',
            tackedReturnFundInceptionDate: null,
            expenseRatioWaiverType: 'CONTRACTUAL',
            expenseRatioWaiverExpirationDate: '2025-02-28T05:00:00Z',
            grossExpenseRatio: 1.12,
            netExpenseRatio: 1.15,
            redemptionFeePeriod: null,
            riskLevelName: 'Moderate',
            sevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            unsubsidizedSevenDayYieldSimple: null,
            returnsAfterTaxesOnDistribution: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            },
            returnsAfterTaxesOnDistributionAndSales: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            }
        },
        {
            broadAssetClass: "Int'l/Global Equity",
            iClass: true,
            morningStarOverallRating: 4,
            morningStarCategoryName: 'Pacific/Asia ex-Japan Stk',
            openToNewInvestors: true,
            openToSubsequentInvestments: true,
            redemptionFee: 0,
            riskLevel: 260,
            taxFree: false,
            ticker: 'TRASX',
            name: 'T. Rowe Price Asia Opportunities Fund - I Class',
            trpCode: 'ASI',
            selectFund: false,
            __typename: 'GraphQLMutualFund',
            shortName: 'Asia Opportunities Fund - I Class',
            morningStarAsOfDate: '2023-02-28T05:00:00Z',
            morningStarOverallQuantity: 48,
            moneyMarket: false,
            moneyMarketType: null,
            ytdMonthlyTotalReturns: 2.54,
            ytdMonthlyAsOfDate: '2023-02-28T05:00:00Z',
            dailyYTDTotalReturns: {
                fundReturn: -11.53,
                asOfDate: '2022-03-07T05:00:00Z',
                __typename: 'FundReturn'
            },
            monthlyAverageAnnualTotalReturns: {
                asOfDate: '2023-02-28T05:00:00Z',
                oneYearReturn: -13.43,
                threeYearReturn: 1.75,
                fiveYearReturn: 1.93,
                tenYearReturn: null,
                sinceInceptionReturn: 6.47,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: true,
                threeYearReturnTacked: false,
                __typename: 'YearlyReturns'
            },
            quarterlyAverageAnnualTotalReturns: {
                asOfDate: '2022-12-31T05:00:00Z',
                oneYearReturn: -18.96,
                threeYearReturn: -0.75,
                fiveYearReturn: 1.76,
                tenYearReturn: null,
                sinceInceptionReturn: 6.29,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: true,
                __typename: 'YearlyReturns'
            },
            inceptionDate: '2017-03-06T05:00:00Z',
            tackedReturnFundInceptionDate: '2014-05-21T04:00:00Z',
            expenseRatioWaiverType: 'CONTRACTUAL',
            expenseRatioWaiverExpirationDate: '2025-02-28T05:00:00Z',
            grossExpenseRatio: 0.92,
            netExpenseRatio: 0.83,
            redemptionFeePeriod: null,
            riskLevelName: 'Moderate',
            sevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            unsubsidizedSevenDayYieldSimple: null,
            returnsAfterTaxesOnDistribution: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            },
            returnsAfterTaxesOnDistributionAndSales: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            }
        },
        {
            broadAssetClass: 'Multi-Asset',
            iClass: true,
            morningStarOverallRating: 3,
            morningStarCategoryName: 'Allocation--50% to 70% Equity',
            openToNewInvestors: true,
            openToSubsequentInvestments: true,
            redemptionFee: 0,
            riskLevel: 250,
            taxFree: false,
            ticker: 'RBAIX',
            name: 'T. Rowe Price Balanced Fund - I Class',
            trpCode: 'BAI',
            selectFund: false,
            __typename: 'GraphQLMutualFund',
            shortName: 'Balanced Fund - I Class',
            morningStarAsOfDate: '2023-02-28T05:00:00Z',
            morningStarOverallQuantity: 683,
            moneyMarket: false,
            moneyMarketType: null,
            ytdMonthlyTotalReturns: 2.93,
            ytdMonthlyAsOfDate: '2023-02-28T05:00:00Z',
            dailyYTDTotalReturns: {
                fundReturn: -9.93,
                asOfDate: '2022-03-07T05:00:00Z',
                __typename: 'FundReturn'
            },
            monthlyAverageAnnualTotalReturns: {
                asOfDate: '2023-02-28T05:00:00Z',
                oneYearReturn: -9.16,
                threeYearReturn: 5.16,
                fiveYearReturn: 4.83,
                tenYearReturn: 7.01,
                sinceInceptionReturn: 9.31,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: true,
                threeYearReturnTacked: false,
                __typename: 'YearlyReturns'
            },
            quarterlyAverageAnnualTotalReturns: {
                asOfDate: '2022-12-31T05:00:00Z',
                oneYearReturn: -17.12,
                threeYearReturn: 2.56,
                fiveYearReturn: 4.42,
                tenYearReturn: 7.07,
                sinceInceptionReturn: 9.29,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: true,
                __typename: 'YearlyReturns'
            },
            inceptionDate: '2015-12-17T05:00:00Z',
            tackedReturnFundInceptionDate: '1939-12-31T05:00:00Z',
            expenseRatioWaiverType: 'CONTRACTUAL',
            expenseRatioWaiverExpirationDate: '2023-04-30T04:00:00Z',
            grossExpenseRatio: 0.49,
            netExpenseRatio: 0.45,
            redemptionFeePeriod: null,
            riskLevelName: 'Moderate',
            sevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            unsubsidizedSevenDayYieldSimple: null,
            returnsAfterTaxesOnDistribution: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            },
            returnsAfterTaxesOnDistributionAndSales: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            }
        },
        {
            broadAssetClass: 'Multi-Asset',
            iClass: false,
            morningStarOverallRating: 4,
            morningStarCategoryName: 'Allocation--50% to 70% Equity',
            openToNewInvestors: true,
            openToSubsequentInvestments: true,
            redemptionFee: 0,
            riskLevel: 250,
            taxFree: false,
            ticker: 'RPBAX',
            name: 'T. Rowe Price Balanced Fund',
            trpCode: 'BAL',
            selectFund: false,
            __typename: 'GraphQLMutualFund',
            shortName: 'Balanced Fund',
            morningStarAsOfDate: '2023-02-28T05:00:00Z',
            morningStarOverallQuantity: 683,
            moneyMarket: false,
            moneyMarketType: null,
            ytdMonthlyTotalReturns: 2.93,
            ytdMonthlyAsOfDate: '2023-02-28T05:00:00Z',
            dailyYTDTotalReturns: {
                fundReturn: -9.96,
                asOfDate: '2022-03-07T05:00:00Z',
                __typename: 'FundReturn'
            },
            monthlyAverageAnnualTotalReturns: {
                asOfDate: '2023-02-28T05:00:00Z',
                oneYearReturn: -9.28,
                threeYearReturn: 5.02,
                fiveYearReturn: 4.69,
                tenYearReturn: 6.91,
                sinceInceptionReturn: 9.29,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: false,
                threeYearReturnTacked: false,
                __typename: 'YearlyReturns'
            },
            quarterlyAverageAnnualTotalReturns: {
                asOfDate: '2022-12-31T05:00:00Z',
                oneYearReturn: -17.26,
                threeYearReturn: 2.42,
                fiveYearReturn: 4.29,
                tenYearReturn: 6.97,
                sinceInceptionReturn: 9.27,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: false,
                __typename: 'YearlyReturns'
            },
            inceptionDate: '1939-12-31T05:00:00Z',
            tackedReturnFundInceptionDate: null,
            expenseRatioWaiverType: 'CONTRACTUAL',
            expenseRatioWaiverExpirationDate: '2023-04-30T04:00:00Z',
            grossExpenseRatio: 0.61,
            netExpenseRatio: 0.57,
            redemptionFeePeriod: null,
            riskLevelName: 'Moderate',
            sevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            unsubsidizedSevenDayYieldSimple: null,
            returnsAfterTaxesOnDistribution: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            },
            returnsAfterTaxesOnDistributionAndSales: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            }
        },
        {
            broadAssetClass: 'US Equity',
            iClass: false,
            morningStarOverallRating: 3,
            morningStarCategoryName: 'Large Growth',
            openToNewInvestors: true,
            openToSubsequentInvestments: true,
            redemptionFee: 0,
            riskLevel: 260,
            taxFree: false,
            ticker: 'TRBCX',
            name: 'T. Rowe Price Blue Chip Growth Fund',
            trpCode: 'BCG',
            selectFund: true,
            __typename: 'GraphQLMutualFund',
            shortName: 'Blue Chip Growth Fund',
            morningStarAsOfDate: '2023-02-28T05:00:00Z',
            morningStarOverallQuantity: 1130,
            moneyMarket: false,
            moneyMarketType: null,
            ytdMonthlyTotalReturns: 7.54,
            ytdMonthlyAsOfDate: '2023-02-28T05:00:00Z',
            dailyYTDTotalReturns: {
                fundReturn: -34.69,
                asOfDate: '2022-11-23T05:00:00Z',
                __typename: 'FundReturn'
            },
            monthlyAverageAnnualTotalReturns: {
                asOfDate: '2023-02-28T05:00:00Z',
                oneYearReturn: -22.33,
                threeYearReturn: 2.86,
                fiveYearReturn: 4.94,
                tenYearReturn: 12.05,
                sinceInceptionReturn: 10.18,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: false,
                threeYearReturnTacked: false,
                __typename: 'YearlyReturns'
            },
            quarterlyAverageAnnualTotalReturns: {
                asOfDate: '2022-12-31T05:00:00Z',
                oneYearReturn: -38.6,
                threeYearReturn: -0.89,
                fiveYearReturn: 5.24,
                tenYearReturn: 11.84,
                sinceInceptionReturn: 9.97,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: false,
                __typename: 'YearlyReturns'
            },
            inceptionDate: '1993-06-30T04:00:00Z',
            tackedReturnFundInceptionDate: null,
            expenseRatioWaiverType: 'NOT_APPLICABLE',
            expenseRatioWaiverExpirationDate: null,
            grossExpenseRatio: 0.69,
            netExpenseRatio: 0.69,
            redemptionFeePeriod: null,
            riskLevelName: 'Moderate',
            sevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            unsubsidizedSevenDayYieldSimple: null,
            returnsAfterTaxesOnDistribution: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            },
            returnsAfterTaxesOnDistributionAndSales: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            }
        },
        {
            broadAssetClass: 'US Equity',
            iClass: true,
            morningStarOverallRating: 0,
            morningStarCategoryName: null,
            openToNewInvestors: true,
            openToSubsequentInvestments: true,
            redemptionFee: 0,
            riskLevel: 260,
            taxFree: false,
            ticker: 'TBCIX',
            name: 'T. Rowe Price Blue Chip Growth Fund - I Class',
            trpCode: 'BCI',
            selectFund: true,
            __typename: 'GraphQLMutualFund',
            shortName: 'Blue Chip Growth Fund - I Class',
            morningStarAsOfDate: null,
            morningStarOverallQuantity: 0,
            moneyMarket: false,
            moneyMarketType: null,
            ytdMonthlyTotalReturns: 7.55,
            ytdMonthlyAsOfDate: '2023-02-28T05:00:00Z',
            dailyYTDTotalReturns: {
                fundReturn: null,
                asOfDate: null,
                __typename: 'FundReturn'
            },
            monthlyAverageAnnualTotalReturns: {
                asOfDate: '2023-02-28T05:00:00Z',
                oneYearReturn: -22.23,
                threeYearReturn: 3,
                fiveYearReturn: 5.08,
                tenYearReturn: 12.15,
                sinceInceptionReturn: 10.22,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: false,
                threeYearReturnTacked: false,
                __typename: 'YearlyReturns'
            },
            quarterlyAverageAnnualTotalReturns: {
                asOfDate: '2022-12-31T05:00:00Z',
                oneYearReturn: -38.51,
                threeYearReturn: -0.75,
                fiveYearReturn: 5.38,
                tenYearReturn: 11.94,
                sinceInceptionReturn: 10.01,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: false,
                __typename: 'YearlyReturns'
            },
            inceptionDate: '2015-12-17T05:00:00Z',
            tackedReturnFundInceptionDate: null,
            expenseRatioWaiverType: 'NOT_APPLICABLE',
            expenseRatioWaiverExpirationDate: null,
            grossExpenseRatio: 0.56,
            netExpenseRatio: 0.56,
            redemptionFeePeriod: null,
            riskLevelName: 'Moderate',
            sevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            unsubsidizedSevenDayYieldSimple: null,
            returnsAfterTaxesOnDistribution: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            },
            returnsAfterTaxesOnDistributionAndSales: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            }
        },
        {
            broadAssetClass: "Int'l/Global Fixed Income",
            iClass: true,
            morningStarOverallRating: 4,
            morningStarCategoryName: 'Global Bond-USD Hedged',
            openToNewInvestors: true,
            openToSubsequentInvestments: true,
            redemptionFee: 0,
            riskLevel: 220,
            taxFree: false,
            ticker: 'TNBMX',
            name:
                'T. Rowe Price International Bond Fund (USD Hedged) - I Class',
            trpCode: 'BHI',
            selectFund: false,
            __typename: 'GraphQLMutualFund',
            shortName: 'International Bond Fund (USD Hedged) - I Class',
            morningStarAsOfDate: '2023-02-28T05:00:00Z',
            morningStarOverallQuantity: 112,
            moneyMarket: false,
            moneyMarketType: null,
            ytdMonthlyTotalReturns: 1.18,
            ytdMonthlyAsOfDate: '2023-02-28T05:00:00Z',
            dailyYTDTotalReturns: {
                fundReturn: -2.44,
                asOfDate: '2022-03-07T05:00:00Z',
                __typename: 'FundReturn'
            },
            monthlyAverageAnnualTotalReturns: {
                asOfDate: '2023-02-28T05:00:00Z',
                oneYearReturn: -8.81,
                threeYearReturn: -2.99,
                fiveYearReturn: 0.57,
                tenYearReturn: null,
                sinceInceptionReturn: 0.79,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: false,
                threeYearReturnTacked: false,
                __typename: 'YearlyReturns'
            },
            quarterlyAverageAnnualTotalReturns: {
                asOfDate: '2022-12-31T05:00:00Z',
                oneYearReturn: -11.81,
                threeYearReturn: -2.85,
                fiveYearReturn: 0.38,
                tenYearReturn: null,
                sinceInceptionReturn: 0.59,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: false,
                __typename: 'YearlyReturns'
            },
            inceptionDate: '2017-09-12T04:00:00Z',
            tackedReturnFundInceptionDate: null,
            expenseRatioWaiverType: 'NOT_APPLICABLE',
            expenseRatioWaiverExpirationDate: null,
            grossExpenseRatio: 0.5,
            netExpenseRatio: 0.5,
            redemptionFeePeriod: null,
            riskLevelName: 'Lower',
            sevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-05-31T04:00:00Z',
            unsubsidizedSevenDayYieldSimple: null,
            returnsAfterTaxesOnDistribution: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            },
            returnsAfterTaxesOnDistributionAndSales: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            }
        },
        {
            broadAssetClass: 'US Fixed Income',
            iClass: false,
            morningStarOverallRating: 4,
            morningStarCategoryName: 'Muni California Long',
            openToNewInvestors: true,
            openToSubsequentInvestments: true,
            redemptionFee: 0,
            riskLevel: 230,
            taxFree: true,
            ticker: 'PRXCX',
            name: 'T. Rowe Price California Tax-Free Bond Fund',
            trpCode: 'CAB',
            selectFund: false,
            __typename: 'GraphQLMutualFund',
            shortName: 'California Tax-Free Bond Fund',
            morningStarAsOfDate: '2023-02-28T05:00:00Z',
            morningStarOverallQuantity: 103,
            moneyMarket: false,
            moneyMarketType: null,
            ytdMonthlyTotalReturns: 0.76,
            ytdMonthlyAsOfDate: '2023-02-28T05:00:00Z',
            dailyYTDTotalReturns: {
                fundReturn: -3.44,
                asOfDate: '2022-03-07T05:00:00Z',
                __typename: 'FundReturn'
            },
            monthlyAverageAnnualTotalReturns: {
                asOfDate: '2023-02-28T05:00:00Z',
                oneYearReturn: -5.71,
                threeYearReturn: -1.64,
                fiveYearReturn: 1.44,
                tenYearReturn: 2.21,
                sinceInceptionReturn: 4.86,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: false,
                threeYearReturnTacked: false,
                __typename: 'YearlyReturns'
            },
            quarterlyAverageAnnualTotalReturns: {
                asOfDate: null, // "2022-12-31T05:00:00Z",
                oneYearReturn: null, // -9.29,
                threeYearReturn: null, // -0.93,
                fiveYearReturn: null, // 1,
                tenYearReturn: null, // 2.25,
                sinceInceptionReturn: null, // 4.86,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: false,
                __typename: 'YearlyReturns'
            },
            inceptionDate: '1986-09-15T04:00:00Z',
            tackedReturnFundInceptionDate: null,
            expenseRatioWaiverType: 'NOT_APPLICABLE',
            expenseRatioWaiverExpirationDate: null,
            grossExpenseRatio: 0.53,
            netExpenseRatio: 0.53,
            redemptionFeePeriod: null,
            riskLevelName: 'Moderate',
            sevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-05-31T04:00:00Z',
            unsubsidizedSevenDayYieldSimple: null,
            returnsAfterTaxesOnDistribution: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            },
            returnsAfterTaxesOnDistributionAndSales: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            }
        },
        {
            broadAssetClass: 'Multi-Asset',
            iClass: false,
            morningStarOverallRating: 5,
            morningStarCategoryName: 'Allocation--50% to 70% Equity',
            openToNewInvestors: false,
            openToSubsequentInvestments: true,
            redemptionFee: 0,
            riskLevel: 240,
            taxFree: false,
            ticker: 'PRWCX',
            name: 'T. Rowe Price Capital Appreciation Fund',
            trpCode: 'CAF',
            selectFund: false,
            __typename: 'GraphQLMutualFund',
            shortName: 'Capital Appreciation Fund',
            morningStarAsOfDate: '2023-02-28T05:00:00Z',
            morningStarOverallQuantity: 683,
            moneyMarket: false,
            moneyMarketType: null,
            ytdMonthlyTotalReturns: 3.06,
            ytdMonthlyAsOfDate: '2023-02-28T05:00:00Z',
            dailyYTDTotalReturns: {
                fundReturn: -7.79,
                asOfDate: '2022-03-07T05:00:00Z',
                __typename: 'FundReturn'
            },
            monthlyAverageAnnualTotalReturns: {
                asOfDate: '2023-02-28T05:00:00Z',
                oneYearReturn: -4.79,
                threeYearReturn: 9.42,
                fiveYearReturn: 9.6,
                tenYearReturn: 10.62,
                sinceInceptionReturn: 11.1,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: false,
                threeYearReturnTacked: false,
                __typename: 'YearlyReturns'
            },
            quarterlyAverageAnnualTotalReturns: {
                asOfDate: '2022-12-31T05:00:00Z',
                oneYearReturn: -11.94,
                threeYearReturn: 7.24,
                fiveYearReturn: 9.11,
                tenYearReturn: 10.83,
                sinceInceptionReturn: 11.06,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: false,
                __typename: 'YearlyReturns'
            },
            inceptionDate: '1986-06-30T04:00:00Z',
            tackedReturnFundInceptionDate: null,
            expenseRatioWaiverType: 'CONTRACTUAL',
            expenseRatioWaiverExpirationDate: '2023-04-30T04:00:00Z',
            grossExpenseRatio: 0.7,
            netExpenseRatio: 0.68,
            redemptionFeePeriod: null,
            riskLevelName: 'Moderate',
            sevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            unsubsidizedSevenDayYieldSimple: null,
            returnsAfterTaxesOnDistribution: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            },
            returnsAfterTaxesOnDistributionAndSales: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            }
        },
        {
            broadAssetClass: 'Multi-Asset',
            iClass: true,
            morningStarOverallRating: 5,
            morningStarCategoryName: 'Allocation--50% to 70% Equity',
            openToNewInvestors: false,
            openToSubsequentInvestments: true,
            redemptionFee: 0,
            riskLevel: 240,
            taxFree: false,
            ticker: 'TRAIX',
            name: 'T. Rowe Price Capital Appreciation Fund - I Class',
            trpCode: 'CAI',
            selectFund: false,
            __typename: 'GraphQLMutualFund',
            shortName: 'Capital Appreciation Fund - I Class',
            morningStarAsOfDate: '2023-02-28T05:00:00Z',
            morningStarOverallQuantity: 683,
            moneyMarket: false,
            moneyMarketType: null,
            ytdMonthlyTotalReturns: 3.1,
            ytdMonthlyAsOfDate: '2023-02-28T05:00:00Z',
            dailyYTDTotalReturns: {
                fundReturn: -7.76,
                asOfDate: '2022-03-07T05:00:00Z',
                __typename: 'FundReturn'
            },
            monthlyAverageAnnualTotalReturns: {
                asOfDate: '2023-02-28T05:00:00Z',
                oneYearReturn: -4.65,
                threeYearReturn: 9.55,
                fiveYearReturn: 9.73,
                tenYearReturn: 10.72,
                sinceInceptionReturn: 11.12,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: true,
                threeYearReturnTacked: false,
                __typename: 'YearlyReturns'
            },
            quarterlyAverageAnnualTotalReturns: {
                asOfDate: '2022-12-31T05:00:00Z',
                oneYearReturn: -11.84,
                threeYearReturn: 7.37,
                fiveYearReturn: 9.23,
                tenYearReturn: 10.92,
                sinceInceptionReturn: 11.08,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: true,
                __typename: 'YearlyReturns'
            },
            inceptionDate: '2015-12-17T05:00:00Z',
            tackedReturnFundInceptionDate: '1986-06-30T04:00:00Z',
            expenseRatioWaiverType: 'CONTRACTUAL',
            expenseRatioWaiverExpirationDate: '2023-04-30T04:00:00Z',
            grossExpenseRatio: 0.59,
            netExpenseRatio: 0.57,
            redemptionFeePeriod: null,
            riskLevelName: 'Moderate',
            sevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            unsubsidizedSevenDayYieldSimple: null,
            returnsAfterTaxesOnDistribution: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            },
            returnsAfterTaxesOnDistributionAndSales: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            }
        },
        {
            broadAssetClass: "Int'l/Global Equity",
            iClass: false,
            morningStarOverallRating: 5,
            morningStarCategoryName: 'China Region',
            openToNewInvestors: true,
            openToSubsequentInvestments: true,
            redemptionFee: 0,
            riskLevel: 280,
            taxFree: false,
            ticker: 'TCELX',
            name: 'T. Rowe Price China Evolution Equity Fund',
            trpCode: 'CEE',
            selectFund: false,
            __typename: 'GraphQLMutualFund',
            shortName: 'China Evolution Equity Fund',
            morningStarAsOfDate: '2023-02-28T05:00:00Z',
            morningStarOverallQuantity: 95,
            moneyMarket: false,
            moneyMarketType: null,
            ytdMonthlyTotalReturns: 5.08,
            ytdMonthlyAsOfDate: '2023-02-28T05:00:00Z',
            dailyYTDTotalReturns: {
                fundReturn: -17.23,
                asOfDate: '2022-03-07T05:00:00Z',
                __typename: 'FundReturn'
            },
            monthlyAverageAnnualTotalReturns: {
                asOfDate: '2023-02-28T05:00:00Z',
                oneYearReturn: -15.94,
                threeYearReturn: 8.53,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: 10.57,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: false,
                threeYearReturnTacked: false,
                __typename: 'YearlyReturns'
            },
            quarterlyAverageAnnualTotalReturns: {
                asOfDate: '2022-12-31T05:00:00Z',
                oneYearReturn: -26.49,
                threeYearReturn: 7.38,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: 9.37,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: false,
                __typename: 'YearlyReturns'
            },
            inceptionDate: '2019-12-10T05:00:00Z',
            tackedReturnFundInceptionDate: null,
            expenseRatioWaiverType: 'CONTRACTUAL',
            expenseRatioWaiverExpirationDate: '2024-02-29T05:00:00Z',
            grossExpenseRatio: 1.45,
            netExpenseRatio: 1.4,
            redemptionFeePeriod: null,
            riskLevelName: 'Higher',
            sevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            unsubsidizedSevenDayYieldSimple: null,
            returnsAfterTaxesOnDistribution: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            },
            returnsAfterTaxesOnDistributionAndSales: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            }
        },
        {
            broadAssetClass: "Int'l/Global Equity",
            iClass: true,
            morningStarOverallRating: 5,
            morningStarCategoryName: 'China Region',
            openToNewInvestors: true,
            openToSubsequentInvestments: true,
            redemptionFee: 0,
            riskLevel: 280,
            taxFree: false,
            ticker: 'TRCLX',
            name: 'T. Rowe Price China Evolution Equity Fund - I Class',
            trpCode: 'CEI',
            selectFund: false,
            __typename: 'GraphQLMutualFund',
            shortName: 'China Evolution Equity Fund - I Class',
            morningStarAsOfDate: '2023-02-28T05:00:00Z',
            morningStarOverallQuantity: 95,
            moneyMarket: false,
            moneyMarketType: null,
            ytdMonthlyTotalReturns: 5.18,
            ytdMonthlyAsOfDate: '2023-02-28T05:00:00Z',
            dailyYTDTotalReturns: {
                fundReturn: -17.2,
                asOfDate: '2022-03-07T05:00:00Z',
                __typename: 'FundReturn'
            },
            monthlyAverageAnnualTotalReturns: {
                asOfDate: '2023-02-28T05:00:00Z',
                oneYearReturn: -15.64,
                threeYearReturn: 8.93,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: 10.99,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: false,
                threeYearReturnTacked: false,
                __typename: 'YearlyReturns'
            },
            quarterlyAverageAnnualTotalReturns: {
                asOfDate: '2022-12-31T05:00:00Z',
                oneYearReturn: -26.25,
                threeYearReturn: 7.78,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: 9.77,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: false,
                __typename: 'YearlyReturns'
            },
            inceptionDate: '2019-12-10T05:00:00Z',
            tackedReturnFundInceptionDate: null,
            expenseRatioWaiverType: 'CONTRACTUAL',
            expenseRatioWaiverExpirationDate: '2024-02-09T05:00:00Z',
            grossExpenseRatio: 1.28,
            netExpenseRatio: 1.03,
            redemptionFeePeriod: null,
            riskLevelName: 'Higher',
            sevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            unsubsidizedSevenDayYieldSimple: null,
            returnsAfterTaxesOnDistribution: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            },
            returnsAfterTaxesOnDistributionAndSales: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            }
        },
        {
            broadAssetClass: 'US Fixed Income',
            iClass: false,
            morningStarOverallRating: 2,
            morningStarCategoryName: 'Corporate Bond',
            openToNewInvestors: true,
            openToSubsequentInvestments: true,
            redemptionFee: 0,
            riskLevel: 230,
            taxFree: false,
            ticker: 'PRPIX',
            name: 'T. Rowe Price Corporate Income Fund',
            trpCode: 'CIF',
            selectFund: false,
            __typename: 'GraphQLMutualFund',
            shortName: 'Corporate Income Fund',
            morningStarAsOfDate: '2023-02-28T05:00:00Z',
            morningStarOverallQuantity: 192,
            moneyMarket: false,
            moneyMarketType: null,
            ytdMonthlyTotalReturns: 1.12,
            ytdMonthlyAsOfDate: '2023-02-28T05:00:00Z',
            dailyYTDTotalReturns: {
                fundReturn: -6.02,
                asOfDate: '2022-03-07T05:00:00Z',
                __typename: 'FundReturn'
            },
            monthlyAverageAnnualTotalReturns: {
                asOfDate: '2023-02-28T05:00:00Z',
                oneYearReturn: -11.36,
                threeYearReturn: -4.61,
                fiveYearReturn: 0.48,
                tenYearReturn: 1.69,
                sinceInceptionReturn: 4.73,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: false,
                threeYearReturnTacked: false,
                __typename: 'YearlyReturns'
            },
            quarterlyAverageAnnualTotalReturns: {
                asOfDate: '2022-12-31T05:00:00Z',
                oneYearReturn: -17.02,
                threeYearReturn: -3.87,
                fiveYearReturn: -0.27,
                tenYearReturn: 1.59,
                sinceInceptionReturn: 4.71,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: false,
                __typename: 'YearlyReturns'
            },
            inceptionDate: '1995-10-31T05:00:00Z',
            tackedReturnFundInceptionDate: null,
            expenseRatioWaiverType: 'NOT_APPLICABLE',
            expenseRatioWaiverExpirationDate: null,
            grossExpenseRatio: 0.56,
            netExpenseRatio: 0.56,
            redemptionFeePeriod: null,
            riskLevelName: 'Moderate',
            sevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-05-31T04:00:00Z',
            unsubsidizedSevenDayYieldSimple: null,
            returnsAfterTaxesOnDistribution: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            },
            returnsAfterTaxesOnDistributionAndSales: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            }
        },
        {
            broadAssetClass: 'US Fixed Income',
            iClass: true,
            morningStarOverallRating: 2,
            morningStarCategoryName: 'Corporate Bond',
            openToNewInvestors: true,
            openToSubsequentInvestments: true,
            redemptionFee: 0,
            riskLevel: 230,
            taxFree: false,
            ticker: 'TICCX',
            name: 'T. Rowe Price Corporate Income Fund - I Class',
            trpCode: 'CII',
            selectFund: false,
            __typename: 'GraphQLMutualFund',
            shortName: 'Corporate Income Fund - I Class',
            morningStarAsOfDate: '2023-02-28T05:00:00Z',
            morningStarOverallQuantity: 192,
            moneyMarket: false,
            moneyMarketType: null,
            ytdMonthlyTotalReturns: 1.15,
            ytdMonthlyAsOfDate: '2023-02-28T05:00:00Z',
            dailyYTDTotalReturns: {
                fundReturn: -6.08,
                asOfDate: '2022-03-07T05:00:00Z',
                __typename: 'FundReturn'
            },
            monthlyAverageAnnualTotalReturns: {
                asOfDate: '2023-02-28T05:00:00Z',
                oneYearReturn: -11.15,
                threeYearReturn: -4.46,
                fiveYearReturn: 0.64,
                tenYearReturn: 1.8,
                sinceInceptionReturn: 4.77,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: true,
                threeYearReturnTacked: false,
                __typename: 'YearlyReturns'
            },
            quarterlyAverageAnnualTotalReturns: {
                asOfDate: '2022-12-31T05:00:00Z',
                oneYearReturn: -16.91,
                threeYearReturn: -3.72,
                fiveYearReturn: -0.11,
                tenYearReturn: 1.7,
                sinceInceptionReturn: 4.75,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: true,
                __typename: 'YearlyReturns'
            },
            inceptionDate: '2015-12-17T05:00:00Z',
            tackedReturnFundInceptionDate: '1995-10-31T05:00:00Z',
            expenseRatioWaiverType: 'CONTRACTUAL',
            expenseRatioWaiverExpirationDate: '2023-09-30T04:00:00Z',
            grossExpenseRatio: 0.44,
            netExpenseRatio: 0.41,
            redemptionFeePeriod: null,
            riskLevelName: 'Moderate',
            sevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-05-31T04:00:00Z',
            unsubsidizedSevenDayYieldSimple: null,
            returnsAfterTaxesOnDistribution: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            },
            returnsAfterTaxesOnDistributionAndSales: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            }
        },
        {
            broadAssetClass: 'US Equity',
            iClass: false,
            morningStarOverallRating: 4,
            morningStarCategoryName: 'Large Blend',
            openToNewInvestors: true,
            openToSubsequentInvestments: true,
            redemptionFee: 0,
            riskLevel: 260,
            taxFree: false,
            ticker: 'PRCOX',
            name: 'T. Rowe Price U.S. Equity Research Fund',
            trpCode: 'COF',
            selectFund: true,
            __typename: 'GraphQLMutualFund',
            shortName: 'U.S. Equity Research Fund',
            morningStarAsOfDate: '2023-02-28T05:00:00Z',
            morningStarOverallQuantity: 1226,
            moneyMarket: false,
            moneyMarketType: null,
            ytdMonthlyTotalReturns: 4.22,
            ytdMonthlyAsOfDate: '2023-02-28T05:00:00Z',
            dailyYTDTotalReturns: {
                fundReturn: -12.23,
                asOfDate: '2022-03-07T05:00:00Z',
                __typename: 'FundReturn'
            },
            monthlyAverageAnnualTotalReturns: {
                asOfDate: '2023-02-28T05:00:00Z',
                oneYearReturn: -8.3,
                threeYearReturn: 12.05,
                fiveYearReturn: 9.89,
                tenYearReturn: 12.38,
                sinceInceptionReturn: 9.22,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: false,
                threeYearReturnTacked: false,
                __typename: 'YearlyReturns'
            },
            quarterlyAverageAnnualTotalReturns: {
                asOfDate: '2022-12-31T05:00:00Z',
                oneYearReturn: -18.8,
                threeYearReturn: 7.58,
                fiveYearReturn: 9.48,
                tenYearReturn: 12.64,
                sinceInceptionReturn: 9.12,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: false,
                __typename: 'YearlyReturns'
            },
            inceptionDate: '1994-11-30T05:00:00Z',
            tackedReturnFundInceptionDate: null,
            expenseRatioWaiverType: 'NOT_APPLICABLE',
            expenseRatioWaiverExpirationDate: null,
            grossExpenseRatio: 0.42,
            netExpenseRatio: 0.42,
            redemptionFeePeriod: null,
            riskLevelName: 'Moderate',
            sevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            unsubsidizedSevenDayYieldSimple: null,
            returnsAfterTaxesOnDistribution: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            },
            returnsAfterTaxesOnDistributionAndSales: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            }
        }
    ]
};

export const pricesAndYieldsAllMutualFundsMock = {
    allMutualFunds: [
        {
            broadAssetClass: 'US Equity',
            iClass: true,
            morningStarOverallRating: 4,
            morningStarCategoryName: 'Small Growth',
            openToNewInvestors: true,
            openToSubsequentInvestments: true,
            redemptionFee: 0,
            riskLevel: 270,
            taxFree: false,
            ticker: 'TQAIX',
            name:
                'T. Rowe Price Integrated U.S. Small-Cap Growth Equity Fund - I Class',
            trpCode: 'QAI',
            selectFund: false,
            __typename: 'GraphQLMutualFund',
            shortName: 'Integrated U.S. Small-Cap Growth Equity Fund - I Class',
            inceptionDate: '2016-03-23T04:00:00Z',
            bond: false,
            moneyMarket: false,
            moneyMarketType: null,
            redemptionFeePeriod: null,
            ytdMonthlyTotalReturns: 15.93,
            ytdMonthlyAsOfDate: '2024-09-30T04:00:00Z',
            dailyYTDTotalReturns: {
                asOfDate: '2024-11-08T05:00:00Z',
                fundReturn: 23.398598017836964,
                __typename: 'FundReturn'
            },
            monthlyAverageAnnualTotalReturns: {
                asOfDate: '2024-09-30T04:00:00Z',
                oneYearReturn: 30.66,
                threeYearReturn: 4.34,
                fiveYearReturn: 10.42,
                tenYearReturn: 10.8,
                sinceInceptionReturn: 8.42,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: true,
                __typename: 'YearlyReturns'
            },
            quarterlyAverageAnnualTotalReturns: {
                asOfDate: '2024-09-30T04:00:00Z',
                oneYearReturn: 30.66,
                threeYearReturn: 4.34,
                fiveYearReturn: 10.42,
                tenYearReturn: 10.8,
                sinceInceptionReturn: 8.42,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: true,
                __typename: 'YearlyReturns'
            },
            assetClass: {
                name: 'Domestic Stock',
                __typename: 'AssetClass'
            },
            tackedReturnFundInceptionDate: '1997-06-30T04:00:00Z',
            grossExpenseRatio: 0.66,
            netExpenseRatio: 0.66,
            expenseRatioWaiverType: 'NOT_APPLICABLE',
            expenseRatioWaiverExpirationDate: null,
            sevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            unsubsidizedSevenDayYieldSimple: null,
            thirtyDaySECDividend: null,
            thirtyDayAnnualizedDividendYield: null,
            thirtyDayAnnualizedDividendYieldAsOfDate: null,
            yield30DayStandard: null,
            yield30DayStandardEffectiveDate: '2024-09-30T04:00:00Z',
            unsubsidizedThirtyDaySECYield: null,
            unsubsidizedThirtyDaySECYieldAsOfDate: '2024-09-30T04:00:00Z',
            returnsAfterTaxesOnDistribution: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            },
            returnsAfterTaxesOnDistributionAndSales: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            }
        },
        {
            broadAssetClass: 'US Equity',
            iClass: false,
            morningStarOverallRating: 4,
            morningStarCategoryName: 'Small Growth',
            openToNewInvestors: true,
            openToSubsequentInvestments: true,
            redemptionFee: 0,
            riskLevel: 270,
            taxFree: false,
            ticker: 'PRDSX',
            name: 'T. Rowe Price Integrated U.S. Small-Cap Growth Equity Fund',
            trpCode: 'DSG',
            selectFund: false,
            __typename: 'GraphQLMutualFund',
            shortName: 'Integrated U.S. Small-Cap Growth Equity Fund',
            inceptionDate: '1997-06-30T04:00:00Z',
            bond: false,
            moneyMarket: false,
            moneyMarketType: null,
            redemptionFeePeriod: null,
            ytdMonthlyTotalReturns: 15.8,
            ytdMonthlyAsOfDate: '2024-09-30T04:00:00Z',
            dailyYTDTotalReturns: {
                asOfDate: '2024-11-08T05:00:00Z',
                fundReturn: 23.243902438455276,
                __typename: 'FundReturn'
            },
            monthlyAverageAnnualTotalReturns: {
                asOfDate: '2024-09-30T04:00:00Z',
                oneYearReturn: 30.45,
                threeYearReturn: 4.19,
                fiveYearReturn: 10.26,
                tenYearReturn: 10.67,
                sinceInceptionReturn: 8.38,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: false,
                __typename: 'YearlyReturns'
            },
            quarterlyAverageAnnualTotalReturns: {
                asOfDate: '2024-09-30T04:00:00Z',
                oneYearReturn: 30.45,
                threeYearReturn: 4.19,
                fiveYearReturn: 10.26,
                tenYearReturn: 10.67,
                sinceInceptionReturn: 8.38,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: false,
                __typename: 'YearlyReturns'
            },
            assetClass: {
                name: 'Domestic Stock',
                __typename: 'AssetClass'
            },
            tackedReturnFundInceptionDate: null,
            grossExpenseRatio: 0.8,
            netExpenseRatio: 0.8,
            expenseRatioWaiverType: 'NOT_APPLICABLE',
            expenseRatioWaiverExpirationDate: null,
            sevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            unsubsidizedSevenDayYieldSimple: null,
            thirtyDaySECDividend: null,
            thirtyDayAnnualizedDividendYield: null,
            thirtyDayAnnualizedDividendYieldAsOfDate: null,
            yield30DayStandard: null,
            yield30DayStandardEffectiveDate: '2024-09-30T04:00:00Z',
            unsubsidizedThirtyDaySECYield: null,
            unsubsidizedThirtyDaySECYieldAsOfDate: '2024-09-30T04:00:00Z',
            returnsAfterTaxesOnDistribution: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            },
            returnsAfterTaxesOnDistributionAndSales: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            }
        },
        {
            broadAssetClass: "Int'l/Global Equity",
            iClass: false,
            morningStarOverallRating: 2,
            morningStarCategoryName: 'Consumer Defensive',
            openToNewInvestors: true,
            openToSubsequentInvestments: true,
            redemptionFee: 0,
            riskLevel: 260,
            taxFree: false,
            ticker: 'PGLOX',
            name: 'T. Rowe Price Global Consumer Fund',
            trpCode: 'GCF',
            selectFund: false,
            __typename: 'GraphQLMutualFund',
            shortName: 'Global Consumer Fund',
            inceptionDate: '2016-06-27T04:00:00Z',
            bond: false,
            moneyMarket: false,
            moneyMarketType: null,
            redemptionFeePeriod: null,
            ytdMonthlyTotalReturns: 13.91,
            ytdMonthlyAsOfDate: '2024-09-30T04:00:00Z',
            dailyYTDTotalReturns: {
                asOfDate: '2024-11-08T05:00:00Z',
                fundReturn: 12.807244499697829,
                __typename: 'FundReturn'
            },
            monthlyAverageAnnualTotalReturns: {
                asOfDate: '2024-09-30T04:00:00Z',
                oneYearReturn: 27.59,
                threeYearReturn: 1.44,
                fiveYearReturn: 8.51,
                tenYearReturn: null,
                sinceInceptionReturn: 8.82,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: false,
                __typename: 'YearlyReturns'
            },
            quarterlyAverageAnnualTotalReturns: {
                asOfDate: '2024-09-30T04:00:00Z',
                oneYearReturn: 27.59,
                threeYearReturn: 1.44,
                fiveYearReturn: 8.51,
                tenYearReturn: null,
                sinceInceptionReturn: 8.82,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: false,
                __typename: 'YearlyReturns'
            },
            assetClass: {
                name: 'International/Global Stock',
                __typename: 'AssetClass'
            },
            tackedReturnFundInceptionDate: null,
            grossExpenseRatio: 1.54,
            netExpenseRatio: 1.05,
            expenseRatioWaiverType: 'CONTRACTUAL',
            expenseRatioWaiverExpirationDate: '2027-02-28T05:00:00Z',
            sevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            unsubsidizedSevenDayYieldSimple: null,
            thirtyDaySECDividend: null,
            thirtyDayAnnualizedDividendYield: null,
            thirtyDayAnnualizedDividendYieldAsOfDate: null,
            yield30DayStandard: null,
            yield30DayStandardEffectiveDate: '2024-09-30T04:00:00Z',
            unsubsidizedThirtyDaySECYield: null,
            unsubsidizedThirtyDaySECYieldAsOfDate: '2024-09-30T04:00:00Z',
            returnsAfterTaxesOnDistribution: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            },
            returnsAfterTaxesOnDistributionAndSales: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            }
        },
        {
            broadAssetClass: 'US Fixed Income',
            iClass: true,
            morningStarOverallRating: 3,
            morningStarCategoryName: 'Intermediate Core-Plus Bond',
            openToNewInvestors: true,
            openToSubsequentInvestments: true,
            redemptionFee: 0,
            riskLevel: 220,
            taxFree: false,
            ticker: 'PTKIX',
            name: 'T. Rowe Price Total Return Fund - I Class',
            trpCode: 'TKI',
            selectFund: true,
            __typename: 'GraphQLMutualFund',
            shortName: 'Total Return Fund - I Class',
            inceptionDate: '2016-11-15T05:00:00Z',
            bond: true,
            moneyMarket: false,
            moneyMarketType: null,
            redemptionFeePeriod: null,
            ytdMonthlyTotalReturns: 5.24,
            ytdMonthlyAsOfDate: '2024-09-30T04:00:00Z',
            dailyYTDTotalReturns: {
                asOfDate: '2024-11-08T05:00:00Z',
                fundReturn: 3.27109615267291,
                __typename: 'FundReturn'
            },
            monthlyAverageAnnualTotalReturns: {
                asOfDate: '2024-09-30T04:00:00Z',
                oneYearReturn: 11.98,
                threeYearReturn: -2.16,
                fiveYearReturn: 0.62,
                tenYearReturn: null,
                sinceInceptionReturn: 2.16,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: false,
                __typename: 'YearlyReturns'
            },
            quarterlyAverageAnnualTotalReturns: {
                asOfDate: '2024-09-30T04:00:00Z',
                oneYearReturn: 11.98,
                threeYearReturn: -2.16,
                fiveYearReturn: 0.62,
                tenYearReturn: null,
                sinceInceptionReturn: 2.16,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: false,
                __typename: 'YearlyReturns'
            },
            assetClass: {
                name: 'Domestic Taxable Bond',
                __typename: 'AssetClass'
            },
            tackedReturnFundInceptionDate: null,
            grossExpenseRatio: 0.39,
            netExpenseRatio: 0.34,
            expenseRatioWaiverType: 'CONTRACTUAL',
            expenseRatioWaiverExpirationDate: '2025-09-30T04:00:00Z',
            sevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2024-10-31T04:00:00Z',
            unsubsidizedSevenDayYieldSimple: null,
            thirtyDaySECDividend: 4.82,
            thirtyDayAnnualizedDividendYield: 5.12,
            thirtyDayAnnualizedDividendYieldAsOfDate: '2024-11-08T05:00:00Z',
            yield30DayStandard: 4.82,
            yield30DayStandardEffectiveDate: '2024-09-30T04:00:00Z',
            unsubsidizedThirtyDaySECYield: 4.78,
            unsubsidizedThirtyDaySECYieldAsOfDate: '2024-09-30T04:00:00Z',
            returnsAfterTaxesOnDistribution: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            },
            returnsAfterTaxesOnDistributionAndSales: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            }
        },
        {
            broadAssetClass: 'US Fixed Income',
            iClass: false,
            morningStarOverallRating: 3,
            morningStarCategoryName: 'Intermediate Core-Plus Bond',
            openToNewInvestors: true,
            openToSubsequentInvestments: true,
            redemptionFee: 0,
            riskLevel: 230,
            taxFree: false,
            ticker: 'PTTFX',
            name: 'T. Rowe Price Total Return Fund',
            trpCode: 'TTF',
            selectFund: true,
            __typename: 'GraphQLMutualFund',
            shortName: 'Total Return Fund',
            inceptionDate: '2016-11-15T05:00:00Z',
            bond: true,
            moneyMarket: false,
            moneyMarketType: null,
            redemptionFeePeriod: null,
            ytdMonthlyTotalReturns: 5.14,
            ytdMonthlyAsOfDate: '2024-09-30T04:00:00Z',
            dailyYTDTotalReturns: {
                asOfDate: '2024-11-08T05:00:00Z',
                fundReturn: 3.152535256286089,
                __typename: 'FundReturn'
            },
            monthlyAverageAnnualTotalReturns: {
                asOfDate: '2024-09-30T04:00:00Z',
                oneYearReturn: 11.97,
                threeYearReturn: -2.3,
                fiveYearReturn: 0.48,
                tenYearReturn: null,
                sinceInceptionReturn: 2.04,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: false,
                __typename: 'YearlyReturns'
            },
            quarterlyAverageAnnualTotalReturns: {
                asOfDate: '2024-09-30T04:00:00Z',
                oneYearReturn: 11.97,
                threeYearReturn: -2.3,
                fiveYearReturn: 0.48,
                tenYearReturn: null,
                sinceInceptionReturn: 2.04,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: false,
                __typename: 'YearlyReturns'
            },
            assetClass: {
                name: 'Domestic Taxable Bond',
                __typename: 'AssetClass'
            },
            tackedReturnFundInceptionDate: null,
            grossExpenseRatio: 0.59,
            netExpenseRatio: 0.47,
            expenseRatioWaiverType: 'CONTRACTUAL',
            expenseRatioWaiverExpirationDate: '2025-09-30T04:00:00Z',
            sevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2024-10-31T04:00:00Z',
            unsubsidizedSevenDayYieldSimple: null,
            thirtyDaySECDividend: 4.69,
            thirtyDayAnnualizedDividendYield: 5.03,
            thirtyDayAnnualizedDividendYieldAsOfDate: '2024-11-08T05:00:00Z',
            yield30DayStandard: 4.69,
            yield30DayStandardEffectiveDate: '2024-09-30T04:00:00Z',
            unsubsidizedThirtyDaySECYield: 4.61,
            unsubsidizedThirtyDaySECYieldAsOfDate: '2024-09-30T04:00:00Z',
            returnsAfterTaxesOnDistribution: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            },
            returnsAfterTaxesOnDistributionAndSales: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            }
        },
        {
            broadAssetClass: 'Multi-Asset',
            iClass: false,
            morningStarOverallRating: 5,
            morningStarCategoryName: 'Target-Date 2020',
            openToNewInvestors: true,
            openToSubsequentInvestments: true,
            redemptionFee: 0,
            riskLevel: 250,
            taxFree: false,
            ticker: 'TRLAX',
            name: 'T. Rowe Price Retirement Income 2020 Fund',
            trpCode: 'RIB',
            selectFund: false,
            __typename: 'GraphQLMutualFund',
            shortName: 'Retirement Income 2020 Fund',
            inceptionDate: '2017-05-25T04:00:00Z',
            bond: true,
            moneyMarket: false,
            moneyMarketType: null,
            redemptionFeePeriod: null,
            ytdMonthlyTotalReturns: 10.94,
            ytdMonthlyAsOfDate: '2024-09-30T04:00:00Z',
            dailyYTDTotalReturns: {
                asOfDate: '2024-11-08T05:00:00Z',
                fundReturn: 11.419662238707682,
                __typename: 'FundReturn'
            },
            monthlyAverageAnnualTotalReturns: {
                asOfDate: '2024-09-30T04:00:00Z',
                oneYearReturn: 19.95,
                threeYearReturn: 3.34,
                fiveYearReturn: 7.17,
                tenYearReturn: null,
                sinceInceptionReturn: 6.83,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: false,
                __typename: 'YearlyReturns'
            },
            quarterlyAverageAnnualTotalReturns: {
                asOfDate: '2024-09-30T04:00:00Z',
                oneYearReturn: 19.95,
                threeYearReturn: 3.34,
                fiveYearReturn: 7.17,
                tenYearReturn: null,
                sinceInceptionReturn: 6.83,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: false,
                __typename: 'YearlyReturns'
            },
            assetClass: {
                name: 'Blended Asset',
                __typename: 'AssetClass'
            },
            tackedReturnFundInceptionDate: null,
            grossExpenseRatio: 0.52,
            netExpenseRatio: 0.52,
            expenseRatioWaiverType: 'NOT_APPLICABLE',
            expenseRatioWaiverExpirationDate: null,
            sevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            unsubsidizedSevenDayYieldSimple: null,
            thirtyDaySECDividend: null,
            thirtyDayAnnualizedDividendYield: null,
            thirtyDayAnnualizedDividendYieldAsOfDate: null,
            yield30DayStandard: null,
            yield30DayStandardEffectiveDate: '2024-09-30T04:00:00Z',
            unsubsidizedThirtyDaySECYield: null,
            unsubsidizedThirtyDaySECYieldAsOfDate: '2024-09-30T04:00:00Z',
            returnsAfterTaxesOnDistribution: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            },
            returnsAfterTaxesOnDistributionAndSales: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            }
        },
        {
            broadAssetClass: 'Multi-Asset',
            iClass: true,
            morningStarOverallRating: 0,
            morningStarCategoryName: 'Target-Date 2020',
            openToNewInvestors: true,
            openToSubsequentInvestments: true,
            redemptionFee: 0,
            riskLevel: 250,
            taxFree: false,
            ticker: 'TRABX',
            name: 'T. Rowe Price Retirement Income 2020 Fund - I Class',
            trpCode: 'INB',
            selectFund: false,
            __typename: 'GraphQLMutualFund',
            shortName: 'Retirement Income 2020 Fund - I Class',
            inceptionDate: '2024-01-17T05:00:00Z',
            bond: false,
            moneyMarket: false,
            moneyMarketType: null,
            redemptionFeePeriod: null,
            ytdMonthlyTotalReturns: 10.54,
            ytdMonthlyAsOfDate: '2024-09-30T04:00:00Z',
            dailyYTDTotalReturns: {
                asOfDate: null,
                fundReturn: null,
                __typename: 'FundReturn'
            },
            monthlyAverageAnnualTotalReturns: {
                asOfDate: '2024-09-30T04:00:00Z',
                oneYearReturn: 19.52,
                threeYearReturn: 3.21,
                fiveYearReturn: 7.09,
                tenYearReturn: null,
                sinceInceptionReturn: 6.78,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: true,
                __typename: 'YearlyReturns'
            },
            quarterlyAverageAnnualTotalReturns: {
                asOfDate: '2024-09-30T04:00:00Z',
                oneYearReturn: 19.52,
                threeYearReturn: 3.21,
                fiveYearReturn: 7.09,
                tenYearReturn: null,
                sinceInceptionReturn: 6.78,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: true,
                __typename: 'YearlyReturns'
            },
            assetClass: {
                name: null,
                __typename: 'AssetClass'
            },
            tackedReturnFundInceptionDate: '2017-05-25T04:00:00Z',
            grossExpenseRatio: 0.37,
            netExpenseRatio: 0.37,
            expenseRatioWaiverType: 'NOT_APPLICABLE',
            expenseRatioWaiverExpirationDate: null,
            sevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: null,
            unsubsidizedSevenDayYieldSimple: null,
            thirtyDaySECDividend: null,
            thirtyDayAnnualizedDividendYield: null,
            thirtyDayAnnualizedDividendYieldAsOfDate: null,
            yield30DayStandard: null,
            yield30DayStandardEffectiveDate: '2024-09-30T04:00:00Z',
            unsubsidizedThirtyDaySECYield: null,
            unsubsidizedThirtyDaySECYieldAsOfDate: '2024-09-30T04:00:00Z',
            returnsAfterTaxesOnDistribution: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            },
            returnsAfterTaxesOnDistributionAndSales: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            }
        },
        {
            broadAssetClass: "Int'l/Global Fixed Income",
            iClass: false,
            morningStarOverallRating: 4,
            morningStarCategoryName: 'Global Bond-USD Hedged',
            openToNewInvestors: true,
            openToSubsequentInvestments: true,
            redemptionFee: 0,
            riskLevel: 230,
            taxFree: false,
            ticker: 'PRSNX',
            name: 'T. Rowe Price Global Multi-Sector Bond Fund',
            trpCode: 'SNF',
            selectFund: true,
            __typename: 'GraphQLMutualFund',
            shortName: 'Global Multi-Sector Bond Fund',
            inceptionDate: '2008-12-15T05:00:00Z',
            bond: true,
            moneyMarket: false,
            moneyMarketType: null,
            redemptionFeePeriod: null,
            ytdMonthlyTotalReturns: 4.85,
            ytdMonthlyAsOfDate: '2024-09-30T04:00:00Z',
            dailyYTDTotalReturns: {
                asOfDate: '2024-11-08T05:00:00Z',
                fundReturn: 4.832778819497725,
                __typename: 'FundReturn'
            },
            monthlyAverageAnnualTotalReturns: {
                asOfDate: '2024-09-30T04:00:00Z',
                oneYearReturn: 12.68,
                threeYearReturn: -0.37,
                fiveYearReturn: 1.76,
                tenYearReturn: 3.02,
                sinceInceptionReturn: 5.11,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: false,
                __typename: 'YearlyReturns'
            },
            quarterlyAverageAnnualTotalReturns: {
                asOfDate: '2024-09-30T04:00:00Z',
                oneYearReturn: 12.68,
                threeYearReturn: -0.37,
                fiveYearReturn: 1.76,
                tenYearReturn: 3.02,
                sinceInceptionReturn: 5.11,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: false,
                __typename: 'YearlyReturns'
            },
            assetClass: {
                name: 'International/Global Bond',
                __typename: 'AssetClass'
            },
            tackedReturnFundInceptionDate: null,
            grossExpenseRatio: 0.73,
            netExpenseRatio: 0.67,
            expenseRatioWaiverType: 'CONTRACTUAL',
            expenseRatioWaiverExpirationDate: '2025-09-30T04:00:00Z',
            sevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2024-10-31T04:00:00Z',
            unsubsidizedSevenDayYieldSimple: null,
            thirtyDaySECDividend: 4.08,
            thirtyDayAnnualizedDividendYield: 4.39,
            thirtyDayAnnualizedDividendYieldAsOfDate: '2024-11-08T05:00:00Z',
            yield30DayStandard: 4.08,
            yield30DayStandardEffectiveDate: '2024-09-30T04:00:00Z',
            unsubsidizedThirtyDaySECYield: 4.06,
            unsubsidizedThirtyDaySECYieldAsOfDate: '2024-09-30T04:00:00Z',
            returnsAfterTaxesOnDistribution: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            },
            returnsAfterTaxesOnDistributionAndSales: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            }
        },
        {
            broadAssetClass: "Int'l/Global Fixed Income",
            iClass: true,
            morningStarOverallRating: 4,
            morningStarCategoryName: 'Global Bond-USD Hedged',
            openToNewInvestors: true,
            openToSubsequentInvestments: true,
            redemptionFee: 0,
            riskLevel: 230,
            taxFree: false,
            ticker: 'PGMSX',
            name: 'T. Rowe Price Global Multi-Sector Bond Fund - I Class',
            trpCode: 'GMI',
            selectFund: true,
            __typename: 'GraphQLMutualFund',
            shortName: 'Global Multi-Sector Bond Fund - I Class',
            inceptionDate: '2016-03-23T04:00:00Z',
            bond: true,
            moneyMarket: false,
            moneyMarketType: null,
            redemptionFeePeriod: null,
            ytdMonthlyTotalReturns: 4.97,
            ytdMonthlyAsOfDate: '2024-09-30T04:00:00Z',
            dailyYTDTotalReturns: {
                asOfDate: '2024-11-08T05:00:00Z',
                fundReturn: 4.981495977027624,
                __typename: 'FundReturn'
            },
            monthlyAverageAnnualTotalReturns: {
                asOfDate: '2024-09-30T04:00:00Z',
                oneYearReturn: 12.87,
                threeYearReturn: -0.2,
                fiveYearReturn: 1.91,
                tenYearReturn: 3.16,
                sinceInceptionReturn: 5.2,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: true,
                __typename: 'YearlyReturns'
            },
            quarterlyAverageAnnualTotalReturns: {
                asOfDate: '2024-09-30T04:00:00Z',
                oneYearReturn: 12.87,
                threeYearReturn: -0.2,
                fiveYearReturn: 1.91,
                tenYearReturn: 3.16,
                sinceInceptionReturn: 5.2,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: true,
                __typename: 'YearlyReturns'
            },
            assetClass: {
                name: 'International/Global Bond',
                __typename: 'AssetClass'
            },
            tackedReturnFundInceptionDate: '2008-12-15T05:00:00Z',
            grossExpenseRatio: 0.59,
            netExpenseRatio: 0.51,
            expenseRatioWaiverType: 'CONTRACTUAL',
            expenseRatioWaiverExpirationDate: '2025-09-30T04:00:00Z',
            sevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2024-10-31T04:00:00Z',
            unsubsidizedSevenDayYieldSimple: null,
            thirtyDaySECDividend: 4.24,
            thirtyDayAnnualizedDividendYield: 4.51,
            thirtyDayAnnualizedDividendYieldAsOfDate: '2024-11-08T05:00:00Z',
            yield30DayStandard: 4.24,
            yield30DayStandardEffectiveDate: '2024-09-30T04:00:00Z',
            unsubsidizedThirtyDaySECYield: 4.19,
            unsubsidizedThirtyDaySECYieldAsOfDate: '2024-09-30T04:00:00Z',
            returnsAfterTaxesOnDistribution: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            },
            returnsAfterTaxesOnDistributionAndSales: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            }
        },
        {
            broadAssetClass: 'US Fixed Income',
            iClass: true,
            morningStarOverallRating: 5,
            morningStarCategoryName: 'Muni Single State Long',
            openToNewInvestors: true,
            openToSubsequentInvestments: true,
            redemptionFee: 0,
            riskLevel: 220,
            taxFree: true,
            ticker: 'TFBIX',
            name: 'T. Rowe Price Maryland Tax-Free Bond Fund - I Class',
            trpCode: 'MBI',
            selectFund: false,
            __typename: 'GraphQLMutualFund',
            shortName: 'Maryland Tax-Free Bond Fund - I Class',
            inceptionDate: '2017-07-06T04:00:00Z',
            bond: true,
            moneyMarket: false,
            moneyMarketType: null,
            redemptionFeePeriod: null,
            ytdMonthlyTotalReturns: 3.93,
            ytdMonthlyAsOfDate: '2024-09-30T04:00:00Z',
            dailyYTDTotalReturns: {
                asOfDate: '2024-11-08T05:00:00Z',
                fundReturn: 2.900213612037885,
                __typename: 'FundReturn'
            },
            monthlyAverageAnnualTotalReturns: {
                asOfDate: '2024-09-30T04:00:00Z',
                oneYearReturn: 12.12,
                threeYearReturn: 0.42,
                fiveYearReturn: 1.59,
                tenYearReturn: 2.57,
                sinceInceptionReturn: 4.79,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: true,
                __typename: 'YearlyReturns'
            },
            quarterlyAverageAnnualTotalReturns: {
                asOfDate: '2024-09-30T04:00:00Z',
                oneYearReturn: 12.12,
                threeYearReturn: 0.42,
                fiveYearReturn: 1.59,
                tenYearReturn: 2.57,
                sinceInceptionReturn: 4.79,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: true,
                __typename: 'YearlyReturns'
            },
            assetClass: {
                name: 'Domestic Tax-Free Bond',
                __typename: 'AssetClass'
            },
            tackedReturnFundInceptionDate: '1987-03-31T05:00:00Z',
            grossExpenseRatio: 0.42,
            netExpenseRatio: 0.42,
            expenseRatioWaiverType: 'NOT_APPLICABLE',
            expenseRatioWaiverExpirationDate: null,
            sevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2024-10-31T04:00:00Z',
            unsubsidizedSevenDayYieldSimple: null,
            thirtyDaySECDividend: 3.52,
            thirtyDayAnnualizedDividendYield: 3.36,
            thirtyDayAnnualizedDividendYieldAsOfDate: '2024-11-08T05:00:00Z',
            yield30DayStandard: 3.52,
            yield30DayStandardEffectiveDate: '2024-09-30T04:00:00Z',
            unsubsidizedThirtyDaySECYield: 3.52,
            unsubsidizedThirtyDaySECYieldAsOfDate: '2024-09-30T04:00:00Z',
            returnsAfterTaxesOnDistribution: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            },
            returnsAfterTaxesOnDistributionAndSales: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            }
        },
        {
            broadAssetClass: 'US Fixed Income',
            iClass: false,
            morningStarOverallRating: 5,
            morningStarCategoryName: 'Muni Single State Long',
            openToNewInvestors: true,
            openToSubsequentInvestments: true,
            redemptionFee: 0,
            riskLevel: 230,
            taxFree: true,
            ticker: 'MDXBX',
            name: 'T. Rowe Price Maryland Tax-Free Bond Fund',
            trpCode: 'MDB',
            selectFund: false,
            __typename: 'GraphQLMutualFund',
            shortName: 'Maryland Tax-Free Bond Fund',
            inceptionDate: '1987-03-31T05:00:00Z',
            bond: true,
            moneyMarket: false,
            moneyMarketType: null,
            redemptionFeePeriod: null,
            ytdMonthlyTotalReturns: 3.88,
            ytdMonthlyAsOfDate: '2024-09-30T04:00:00Z',
            dailyYTDTotalReturns: {
                asOfDate: '2024-11-08T05:00:00Z',
                fundReturn: 2.835608345449758,
                __typename: 'FundReturn'
            },
            monthlyAverageAnnualTotalReturns: {
                asOfDate: '2024-09-30T04:00:00Z',
                oneYearReturn: 12.05,
                threeYearReturn: 0.34,
                fiveYearReturn: 1.51,
                tenYearReturn: 2.51,
                sinceInceptionReturn: 4.77,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: false,
                __typename: 'YearlyReturns'
            },
            quarterlyAverageAnnualTotalReturns: {
                asOfDate: '2024-09-30T04:00:00Z',
                oneYearReturn: 12.05,
                threeYearReturn: 0.34,
                fiveYearReturn: 1.51,
                tenYearReturn: 2.51,
                sinceInceptionReturn: 4.77,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: false,
                __typename: 'YearlyReturns'
            },
            assetClass: {
                name: 'Domestic Tax-Free Bond',
                __typename: 'AssetClass'
            },
            tackedReturnFundInceptionDate: null,
            grossExpenseRatio: 0.53,
            netExpenseRatio: 0.49,
            expenseRatioWaiverType: 'CONTRACTUAL',
            expenseRatioWaiverExpirationDate: '2025-06-30T04:00:00Z',
            sevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2024-10-31T04:00:00Z',
            unsubsidizedSevenDayYieldSimple: null,
            thirtyDaySECDividend: 3.45,
            thirtyDayAnnualizedDividendYield: 3.32,
            thirtyDayAnnualizedDividendYieldAsOfDate: '2024-11-08T05:00:00Z',
            yield30DayStandard: 3.45,
            yield30DayStandardEffectiveDate: '2024-09-30T04:00:00Z',
            unsubsidizedThirtyDaySECYield: 3.41,
            unsubsidizedThirtyDaySECYieldAsOfDate: '2024-09-30T04:00:00Z',
            returnsAfterTaxesOnDistribution: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            },
            returnsAfterTaxesOnDistributionAndSales: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            }
        },
        {
            broadAssetClass: 'US Fixed Income',
            iClass: false,
            morningStarOverallRating: 2,
            morningStarCategoryName: 'Muni Single State Short',
            openToNewInvestors: true,
            openToSubsequentInvestments: true,
            redemptionFee: 0,
            riskLevel: 210,
            taxFree: true,
            ticker: 'PRMDX',
            name: 'T. Rowe Price Maryland Short-Term Tax-Free Bond Fund',
            trpCode: 'MDS',
            selectFund: false,
            __typename: 'GraphQLMutualFund',
            shortName: 'Maryland Short-Term Tax-Free Bond Fund',
            inceptionDate: '1993-01-29T05:00:00Z',
            bond: true,
            moneyMarket: false,
            moneyMarketType: null,
            redemptionFeePeriod: null,
            ytdMonthlyTotalReturns: 2.35,
            ytdMonthlyAsOfDate: '2024-09-30T04:00:00Z',
            dailyYTDTotalReturns: {
                asOfDate: '2024-11-08T05:00:00Z',
                fundReturn: 2.037175079242686,
                __typename: 'FundReturn'
            },
            monthlyAverageAnnualTotalReturns: {
                asOfDate: '2024-09-30T04:00:00Z',
                oneYearReturn: 5.37,
                threeYearReturn: 1.17,
                fiveYearReturn: 1.07,
                tenYearReturn: 0.98,
                sinceInceptionReturn: 2.32,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: false,
                __typename: 'YearlyReturns'
            },
            quarterlyAverageAnnualTotalReturns: {
                asOfDate: '2024-09-30T04:00:00Z',
                oneYearReturn: 5.37,
                threeYearReturn: 1.17,
                fiveYearReturn: 1.07,
                tenYearReturn: 0.98,
                sinceInceptionReturn: 2.32,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: false,
                __typename: 'YearlyReturns'
            },
            assetClass: {
                name: 'Domestic Tax-Free Bond',
                __typename: 'AssetClass'
            },
            tackedReturnFundInceptionDate: null,
            grossExpenseRatio: 0.75,
            netExpenseRatio: 0.53,
            expenseRatioWaiverType: 'CONTRACTUAL',
            expenseRatioWaiverExpirationDate: '2026-04-30T04:00:00Z',
            sevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2024-10-31T04:00:00Z',
            unsubsidizedSevenDayYieldSimple: null,
            thirtyDaySECDividend: 2.33,
            thirtyDayAnnualizedDividendYield: 2.46,
            thirtyDayAnnualizedDividendYieldAsOfDate: '2024-11-08T05:00:00Z',
            yield30DayStandard: 2.33,
            yield30DayStandardEffectiveDate: '2024-09-30T04:00:00Z',
            unsubsidizedThirtyDaySECYield: 2.09,
            unsubsidizedThirtyDaySECYieldAsOfDate: '2024-09-30T04:00:00Z',
            returnsAfterTaxesOnDistribution: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            },
            returnsAfterTaxesOnDistributionAndSales: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            }
        },
        {
            broadAssetClass: 'US Fixed Income',
            iClass: true,
            morningStarOverallRating: 2,
            morningStarCategoryName: 'Inflation-Protected Bond',
            openToNewInvestors: true,
            openToSubsequentInvestments: true,
            redemptionFee: 0,
            riskLevel: 230,
            taxFree: false,
            ticker: 'TIIPX',
            name: 'T. Rowe Price Inflation Protected Bond Fund - I Class',
            trpCode: 'IPI',
            selectFund: false,
            __typename: 'GraphQLMutualFund',
            shortName: 'Inflation Protected Bond Fund - I Class',
            inceptionDate: '2015-12-17T05:00:00Z',
            bond: true,
            moneyMarket: false,
            moneyMarketType: null,
            redemptionFeePeriod: null,
            ytdMonthlyTotalReturns: 4.91,
            ytdMonthlyAsOfDate: '2024-09-30T04:00:00Z',
            dailyYTDTotalReturns: {
                asOfDate: '2024-11-08T05:00:00Z',
                fundReturn: 3.258628476647867,
                __typename: 'FundReturn'
            },
            monthlyAverageAnnualTotalReturns: {
                asOfDate: '2024-09-30T04:00:00Z',
                oneYearReturn: 9.54,
                threeYearReturn: -1.38,
                fiveYearReturn: 2.15,
                tenYearReturn: 2.23,
                sinceInceptionReturn: 3.65,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: true,
                __typename: 'YearlyReturns'
            },
            quarterlyAverageAnnualTotalReturns: {
                asOfDate: '2024-09-30T04:00:00Z',
                oneYearReturn: 9.54,
                threeYearReturn: -1.38,
                fiveYearReturn: 2.15,
                tenYearReturn: 2.23,
                sinceInceptionReturn: 3.65,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: true,
                __typename: 'YearlyReturns'
            },
            assetClass: {
                name: 'Domestic Taxable Bond',
                __typename: 'AssetClass'
            },
            tackedReturnFundInceptionDate: '2002-10-31T05:00:00Z',
            grossExpenseRatio: 0.46,
            netExpenseRatio: 0.22,
            expenseRatioWaiverType: 'CONTRACTUAL',
            expenseRatioWaiverExpirationDate: '2025-09-30T04:00:00Z',
            sevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2024-10-31T04:00:00Z',
            unsubsidizedSevenDayYieldSimple: null,
            thirtyDaySECDividend: 4.1,
            thirtyDayAnnualizedDividendYield: 1.6,
            thirtyDayAnnualizedDividendYieldAsOfDate: '2024-11-08T05:00:00Z',
            yield30DayStandard: 4,
            yield30DayStandardEffectiveDate: '2024-09-30T04:00:00Z',
            unsubsidizedThirtyDaySECYield: 4,
            unsubsidizedThirtyDaySECYieldAsOfDate: '2024-09-30T04:00:00Z',
            returnsAfterTaxesOnDistribution: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            },
            returnsAfterTaxesOnDistributionAndSales: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            }
        },
        {
            broadAssetClass: 'US Fixed Income',
            iClass: false,
            morningStarOverallRating: 3,
            morningStarCategoryName: 'Inflation-Protected Bond',
            openToNewInvestors: true,
            openToSubsequentInvestments: true,
            redemptionFee: 0,
            riskLevel: 230,
            taxFree: false,
            ticker: 'PRIPX',
            name: 'T. Rowe Price Inflation Protected Bond Fund',
            trpCode: 'IPB',
            selectFund: false,
            __typename: 'GraphQLMutualFund',
            shortName: 'Inflation Protected Bond Fund',
            inceptionDate: '2002-10-31T05:00:00Z',
            bond: true,
            moneyMarket: false,
            moneyMarketType: null,
            redemptionFeePeriod: null,
            ytdMonthlyTotalReturns: 4.74,
            ytdMonthlyAsOfDate: '2024-09-30T04:00:00Z',
            dailyYTDTotalReturns: {
                asOfDate: '2024-11-08T05:00:00Z',
                fundReturn: 3.061474622126597,
                __typename: 'FundReturn'
            },
            monthlyAverageAnnualTotalReturns: {
                asOfDate: '2024-09-30T04:00:00Z',
                oneYearReturn: 9.29,
                threeYearReturn: -1.58,
                fiveYearReturn: 1.96,
                tenYearReturn: 2.08,
                sinceInceptionReturn: 3.57,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: false,
                __typename: 'YearlyReturns'
            },
            quarterlyAverageAnnualTotalReturns: {
                asOfDate: '2024-09-30T04:00:00Z',
                oneYearReturn: 9.29,
                threeYearReturn: -1.58,
                fiveYearReturn: 1.96,
                tenYearReturn: 2.08,
                sinceInceptionReturn: 3.57,
                cumulativeSinceInceptionReturn: null,
                sinceInceptionReturnTacked: false,
                __typename: 'YearlyReturns'
            },
            assetClass: {
                name: 'Domestic Taxable Bond',
                __typename: 'AssetClass'
            },
            tackedReturnFundInceptionDate: null,
            grossExpenseRatio: 0.66,
            netExpenseRatio: 0.41,
            expenseRatioWaiverType: 'CONTRACTUAL',
            expenseRatioWaiverExpirationDate: '2025-09-30T04:00:00Z',
            sevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2024-10-31T04:00:00Z',
            unsubsidizedSevenDayYieldSimple: null,
            thirtyDaySECDividend: 2.75,
            thirtyDayAnnualizedDividendYield: 1.42,
            thirtyDayAnnualizedDividendYieldAsOfDate: '2024-11-08T05:00:00Z',
            yield30DayStandard: 2.75,
            yield30DayStandardEffectiveDate: '2024-09-30T04:00:00Z',
            unsubsidizedThirtyDaySECYield: 2.54,
            unsubsidizedThirtyDaySECYieldAsOfDate: '2024-09-30T04:00:00Z',
            returnsAfterTaxesOnDistribution: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            },
            returnsAfterTaxesOnDistributionAndSales: {
                oneYearReturn: null,
                threeYearReturn: null,
                fiveYearReturn: null,
                tenYearReturn: null,
                sinceInceptionReturn: null,
                __typename: 'YearlyReturns'
            }
        }
    ]
};
